const funcion13 = {
    titulo: `Función: parámetros rest`,
    problemas: [
      {
        codigo: 1,
        descripcion: `La sintaxis de los parámetros rest nos permite recibir una cantidad variables de datos que se almacenan en un Array.
Debemos anteceder tres puntos antes del nombre del parámetro para indicar que es un parámetro rest.`,
        programa: `function sumar(...numeros) {
  let suma = 0
  for (let i = 0; i < numeros.length; i++) {
    suma += numeros[i]
  }
  return suma
}
          
console.log(sumar(1, 2, 3, 4, 5))`,
        solucion: "15"
      }, {
        codigo: 2,
        descripcion: `Como el parámetro rest se trata realmente de un arreglo, luego podemos usar los métodos de la clase Array para trabajar con él.`,
        programa: `function mostrarOrdenados(...numeros) {
  numeros.sort((a, b) => a - b)
  console.log(numeros)
}
      
mostrarOrdenados(10, 50, 13, 120, 31)`,
        solucion: "[10, 13, 31, 50, 120]"
      }, {
        codigo: 3,
        descripcion: `En el caso de haber más de un parámetro deben estar declarados antes del parámetro rest.`,
        programa: `function mostrarEmpleado(nombre, ...sueldos) {
  console.log([nombre, sueldos])
}
      
mostrarEmpleado("Juan", 100, 200, 300)`,
        solucion: "['Juan', [100, 200, 300]]"
      }, {
        codigo: 4,
        descripcion: `Se genera un error sintáxtico si intentamos definir primero el parámetro rest.`,
        programa: `function mostrarEmpleado(...sueldos, nombre) {
  console.log([nombre, sueldos])
}
      
mostrarEmpleado(100, 200, 300, "Juan")`,
        solucion: ""
      }
    ]
  }
  
  export default funcion13;